import { HALF_SLOTS } from "./tiers";
import { parseTime } from "./time";

// Coach availability windows. Shape on a coach:
//   availability: { Monday: { start: "3:00 PM", end: "8:00 PM" }, ... }
// A day present with a window means the coach can work that window; a day
// absent means they can't work that day. A coach with NO availability object
// (the default for every existing coach) carries no constraint at all — they
// count as available anytime, so turning this feature on never retroactively
// flags coaches who were fine before.

// Start-time choices for a window (every half hour, 6:00 AM–9:30 PM), and end
// choices shifted one slot later so a window can close as late as 10:00 PM.
export const AVAIL_START_OPTIONS = HALF_SLOTS;
export const AVAIL_END_OPTIONS = [...HALF_SLOTS.slice(1), "10:00 PM"];

export function hasAvailabilityConstraints(coach) {
  return !!(coach && coach.availability && Object.keys(coach.availability).length > 0);
}

// Is `coach` free to staff a session on `day` running [startTime, +duration)?
// Unconstrained coaches are always free. When constrained, the whole session
// must fall inside that day's window.
export function coachAvailableFor(coach, day, startTime, duration) {
  if (!hasAvailabilityConstraints(coach)) return true;
  const win = coach.availability[day];
  if (!win || !win.start || !win.end) return false; // day not listed → off that day
  const start = parseTime(startTime);
  const end = start != null && duration ? start + duration * 60 : null;
  const winStart = parseTime(win.start);
  const winEnd = parseTime(win.end);
  if (start == null || end == null || winStart == null || winEnd == null) return true;
  return start >= winStart && end <= winEnd;
}

// Compact human summary of a coach's availability, e.g.
// "Mon–Wed 3:00 PM–8:00 PM · Sat 8:00 AM–12:00 PM" (or null if unconstrained).
export function availabilitySummary(coach) {
  if (!hasAvailabilityConstraints(coach)) return null;
  return Object.entries(coach.availability)
    .map(([day, w]) => `${day.slice(0, 3)} ${w.start}–${w.end}`)
    .join(" · ");
}
